export default __webpack_public_path__ + "static/media/check-mark.ace21949.svg";